import { Pipe, PipeTransform } from '@angular/core';
import { IWizardContact } from '../models';

@Pipe({
    name: 'checkIsVIP'
})
export class CheckIsVIPPipe implements PipeTransform {
    transform(contact: IWizardContact, allVIPContacts: IWizardContact[]) {
        const result = Boolean(
            allVIPContacts.find((vipContact) => {
                return vipContact.id === contact.id;
            })
        );

        return result;
    }
}
